<template>
  <div class="transparent" :class="{'mx-auto': $vuetify.breakpoint.lgAndUp}">
    <div
      v-if="$route.name === 'Inicio'"
      class="d-flex d-md-none pt-0"
    >
      <div
        class="mb-3 pb-0 isFree overflow-hidden"
        :class="{'isPremium': user.is_premium}"
      >
        <p
          class="isPremium__text my-1"
          :class="{'isFree__text': !user.is_premium}"
        >
          {{ user.is_premium ? 'VIP': 'FREE'}}
        </p>
        <v-btn @click="clickFoto()" text width="53px" height="53px" fab>
          <v-img
            class="d-flex d-md-none white rounded-circle border-solid-4 mt-auto mb-0"
            :src=" fotoPerfil"
            alt="Foto Perfil Usuario"
            height="53px"
            width="53px"
          />
        </v-btn>
      </div>
    </div>
    <div class="d-none d-md-flex ml-8 my-3">
      <div
        class="mb-1 pb-0 pt-0 isFree overflow-hidden"
        :class="{'isPremium': user.is_premium}"
        style="border: 1px solid #E8E8E8;"
      >
        <p
          class="isPremium__text my-1"
          :class="{'isFree__text': !user.is_premium}"
          style="font-size: 15px !important;"
        >
          {{ user.is_premium ? 'VIP': 'FREE'}}
        </p>
        <v-btn :width="tamanioFoto" :height="tamanioFoto" fab text @click="clickFoto ()">
          <v-img
            class="d-none d-sm-none d-md-flex d-lg-flex white rounded-circle border-solid-4 ma-0"
            :src=" fotoPerfil"
            alt="Foto Perfil Usuario"
            :height="tamanioFoto"
            :width="tamanioFoto"
          />
        </v-btn>
      </div>
    </div>
    <div flat class="transparent" :class="{ 'ml-10': $route.name !== 'Inicio' }" v-if="conditions">
      <p class="d-flex d-md-none nombre-foto-w ml-2 font-weight-6 font-size-1-2 text-truncate">
        <span>
          {{user.genero ? user.genero.pronombre : null}} {{ nombreUsuario }}
        </span>
      </p>
      <p class="d-none d-md-flex nombre-foto-desk d-lg-flex font-weight-6 font-size-1-2 text-truncate">
        <span>
          {{user.genero ? user.genero.pronombre : null}} {{ nombreUsuario }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CardAvatarSingle',
  props: {
    nombreUsuario: {
      type: String,
      default: ''
    },
    fotoPerfil: {
      type: String,
      default: ''
    },
    tamanioFoto: {
      type: String,
      default: '53px'
    }
  },
  computed: {
    ...mapState('perfil', ['user']),
    conditions () {
      return this.$route.name === 'Inicio' || (!this.$vuetify.breakpoint.smAndDown)
    }
  },
  methods: {
    clickFoto () {
      this.$emit('clickFoto')
    }
  }
}
</script>

<style lang="scss" scoped>
.transparent {
  background-color: transparent!important;
  border-color: transparent!important;
 }
 .nombre-foto-w {
  z-index: 1;
  color: white;
}
.nombre-foto-desk {
  width: 250px;
  white-space: wrap;
  text-overflow: ellipsis !important;
  overflow: hidden;
}
.isFree {
  background: #FFFFFF;
  border-radius: 15px 15px 39px 39px;
  /* transform: rotate(-180deg); */

  &__text{
    font-weight: 800;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.05em;
    background: -webkit-linear-gradient(270deg, #1DBCD1 100%, #19B2D3 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.isPremium {
  background: linear-gradient(90deg, #AB7A57 0%, #DEB580 100%);
  border-radius: 15px 15px 39px 39px ;
  &__text {
    color: #FFFFFF !important;
    font-weight: 800;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.05em;
  }
}
</style>
